import { ITimeLineConfig } from 'Modules'

export enum SellingStatusEnum {
  OFF_SALE = 1,
  ON_SALE = 2,
  SOLD_OUT = 3,
}

export const SELLING_STATUS_CONFIG: Record<SellingStatusEnum, { label: string; color: string }> = {
  [SellingStatusEnum.OFF_SALE]: { label: 'Off Sale', color: 'default' },
  [SellingStatusEnum.ON_SALE]: { label: 'On Sale', color: 'processing' },
  [SellingStatusEnum.SOLD_OUT]: { label: 'Sold Out', color: 'success' },
}

export const CONTRACT_NAME_MAX_LENGTH = 50

export const DISPLAY_TOOLTIP =
  'Choose to display PTO on user website or not. When the switch is ON, show the PTO. When the switch is OFF, hide the PTO.'

export const PHASE_ITEMS = [
  {
    name: 'upcoming',
    required: true,
    enabled: true,
    isPurchasePhase: false,
    isEndTimeUnlimited: false,
  },
  {
    name: 'whitelist',
    isPurchasePhase: true,
    isEndTimeUnlimited: false,
  },
  {
    name: 'calculating',
    isPurchasePhase: false,
    isEndTimeUnlimited: false,
  },
  {
    name: 'fcfs',
    required: true,
    enabled: true,
    isPurchasePhase: true,
    isEndTimeUnlimited: true,
  },
  {
    name: 'end',
    isPurchasePhase: false,
    isEndTimeUnlimited: false,
  },
] as ITimeLineConfig[]
